import "./styles.less";

import { Card, Col, Row } from "antd";

import React from "react";

interface OwnerProps {
	owner: any;
}

export const OfficeHours = ({ owner }: OwnerProps) => {
	const subsidiaries = owner?.subsidiaries;

	return (
		<div className="site-card-wrapper">
			<Row gutter={[8, 8]}>
				{subsidiaries &&
					subsidiaries?.map((subsidiarie, i) => (
						<Col key={i} span={24} md={8}>
							<Card size="small" title={subsidiarie.name} className="office-hours">
								{subsidiarie.address && (
									<p>
										<span className="boldText">Dirección: </span>
										{subsidiarie.address}
									</p>
								)}
								{subsidiarie.office_hours && (
									<p>
										<span className="boldText">Horario: </span>
										{subsidiarie.office_hours}
									</p>
								)}
							</Card>
						</Col>
					))}
			</Row>
		</div>
	);
};
